module.exports = __webpack_public_path__ + "static/feature-hints-and-actions-cfd2f8e6821ebceeef2006bfefd6cfe7.mp4";